import template from './email-list.html';
import controller from './email-list.controller';

let emailListComponent = {
  bindings: {},
  template,
  controller
};

export default emailListComponent;



// WEBPACK FOOTER //
// ./client/app/components/email/email-list.component.js